import React from 'react'
import styles from './Banner.module.less'
import defaultBanner from './default-banner.svg'

const Banner: React.FC = () => {
  return (
    <div className={styles['banner-wrap']}>
      <img className={styles['default-img']} src={defaultBanner} />
    </div>
  )
}

export default Banner
